import { useQuery } from "@tanstack/react-query";
import { mcpClient } from "../../lib/mcp-client";
import type { WorkspaceTasksResult } from "../../lib/types";

interface ListMyTasksParams {
  /** Include `done` tasks. */
  includeDone?: boolean;
  limit?: number;
}

/**
 * Active tasks across the whole workspace (Sprint 26.0). Wraps the
 * `list_workspace_tasks` MCP tool — the cross-agent roll-up that backs the
 * "what's on my plate" surfaces (MyTasks page + badge). Polls at 30s so
 * cross-host task changes appear without a manual refresh.
 *
 * Sprint 26.0 replaced per-user task assignment with the one task noun; this
 * now surfaces every active task in the workspace rather than only the
 * authenticated user's.
 */
export function useListMyTasks(params: ListMyTasksParams = {}) {
  const { includeDone, limit } = params;
  return useQuery<WorkspaceTasksResult>({
    queryKey: ["my-tasks", includeDone ?? false, limit ?? "all"],
    queryFn: () => mcpClient.listWorkspaceTasks({ includeDone, limit }),
    staleTime: 15_000,
    refetchInterval: 30_000,
  });
}
